/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { StringListSearch } from './StringListSearch';
import {
    StringListSearchFromJSON,
    StringListSearchFromJSONTyped,
    StringListSearchToJSON,
} from './StringListSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface RechercheAgrementLocalisationSearch
 */
export interface RechercheAgrementLocalisationSearch {
    /**
     * 
     * @type {TextSearch}
     * @memberof RechercheAgrementLocalisationSearch
     */
    anneeAcademique?: TextSearch;
    /**
     * 
     * @type {StringListSearch}
     * @memberof RechercheAgrementLocalisationSearch
     */
    centre?: StringListSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof RechercheAgrementLocalisationSearch
     */
    statutLocalisationAgrement?: TextSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof RechercheAgrementLocalisationSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof RechercheAgrementLocalisationSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof RechercheAgrementLocalisationSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RechercheAgrementLocalisationSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof RechercheAgrementLocalisationSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof RechercheAgrementLocalisationSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the RechercheAgrementLocalisationSearch interface.
 */
export function instanceOfRechercheAgrementLocalisationSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RechercheAgrementLocalisationSearchFromJSON(json: any): RechercheAgrementLocalisationSearch {
    return RechercheAgrementLocalisationSearchFromJSONTyped(json, false);
}

export function RechercheAgrementLocalisationSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): RechercheAgrementLocalisationSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'anneeAcademique': !exists(json, 'anneeAcademique') ? undefined : TextSearchFromJSON(json['anneeAcademique']),
        'centre': !exists(json, 'centre') ? undefined : StringListSearchFromJSON(json['centre']),
        'statutLocalisationAgrement': !exists(json, 'statutLocalisationAgrement') ? undefined : TextSearchFromJSON(json['statutLocalisationAgrement']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function RechercheAgrementLocalisationSearchToJSON(value?: RechercheAgrementLocalisationSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'anneeAcademique': TextSearchToJSON(value.anneeAcademique),
        'centre': StringListSearchToJSON(value.centre),
        'statutLocalisationAgrement': TextSearchToJSON(value.statutLocalisationAgrement),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

